import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/card/Card';

const SpotListMonthlyHelp = ({
    monthlyPhoneNumber,
    monthlyPhoneNumberFriendly,
}) => {
    return (
        <Card className="SpotList-monthly-help">
            <p>
                Questions about monthly parking?{' '}
                <span>
                    Give us a call at{' '}
                    <a href={`tel:${monthlyPhoneNumber}`}>
                        {monthlyPhoneNumberFriendly}
                    </a>
                    .
                </span>
            </p>
        </Card>
    );
};

SpotListMonthlyHelp.propTypes = {
    monthlyPhoneNumber: PropTypes.string,
    monthlyPhoneNumberFriendly: PropTypes.string,
};

export default SpotListMonthlyHelp;
